<template>
  <div class="default-infos" :class="{'two' : !$slots.right_item}">
    <div class="all-items">
      <div class="item">
        <slot name="left_item"></slot>
      </div>
      <div class="item" :class="{'no-border' : !$slots.right_item}">
        <slot name="mid_item"></slot>
      </div>
      <div class="item no-border">
        <slot name="right_item"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "default-infos",

}
</script>

<style scoped>

</style>